<template>
  <div class="expert-detail">
    <div class="detail-container" v-if="!loading">
      <div class="expert-header">
        <div class="expert-image-wrapper">
          <img :src="expert.image" :alt="expert.name" class="expert-image" />
        </div>
        <div class="expert-basic-info">
          <h1 class="expert-name">{{ expert.name }}</h1>
          <p class="expert-title">{{ expert.title }}</p>
        </div>
      </div>
      
      <div class="expert-content">
        <div class="info-section">
          <h2>个人简介</h2>
          <p>{{ expert.description }}</p>
        </div>
        
        <div class="info-section" v-if="expert.specialties">
          <h2>专业领域</h2>
          <ul class="specialty-list">
            <li v-for="(specialty, index) in expert.specialties" :key="index">
              {{ specialty }}
            </li>
          </ul>
        </div>
        
        <!-- <div class="info-section" v-if="expert.qualifications">
          <h2>资质认证</h2>
          <ul class="qualification-list">
            <li v-for="(qualification, index) in expert.qualifications" :key="index">
              {{ qualification }}
            </li>
          </ul>
        </div> -->
      </div>
      
      <div class="back-button">
        <button @click="goBack">返回列表</button>
      </div>
    </div>
    
    <div class="loading-container" v-else>
      <p>加载中...</p>
    </div>
  </div>
</template>

<script>
import api from '@/api/index.js'

export default {
  name: 'ExpertDetail',
  props: {
    id: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      expert: {
        id: null,
        name: '',
        title: '',
        image: '',
        description: '',
        specialties: [],
        qualifications: []
      },
      loading: false
    }
  },
  created() {
    this.loadExpertData()
  },
  methods: {
    async loadExpertData() {
      // 优先使用 props 传递的 id，其次使用路由参数
      const expertId = this.id || this.$route.params.id
      
      if (!expertId) {
        console.error('未提供专家ID')
        return
      }

      this.loading = true
      
      try {
        const res = await api.detail({ id: expertId })
        
        if (res.code === 2000 && res.data) {
          // 根据实际 API 返回的数据结构进行映射
          this.expert = {
            id: res.data.id,
            name: res.data.name || '',
            title: res.data.title || '',
            image: res.data.photo || '',
            description: res.data.intro || '',
            specialties: res.data.content ? res.data.content.split('。').filter(item => item.trim()) : [],
            qualifications: []
          }
        } else {
          console.error('获取专家详情失败:', res.msg)
        }
      } catch (error) {
        console.error('加载专家数据出错:', error)
      } finally {
        this.loading = false
      }
    },
    goBack() {
      this.$router.back()
    }
  }
}
</script>

<style scoped>
.expert-detail {
  min-height: 100vh;
  background: #f5f5f5;
  padding: 40px 20px;
}

.detail-container {
  max-width: 1200px;
  margin: 0 auto;
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.expert-header {
  display: flex;
  gap: 40px;
  padding: 40px;
  background: linear-gradient(135deg, #B8D9E8 0%, #E8F4F9 100%);
}

.expert-image-wrapper {
  flex-shrink: 0;
  width: 300px;
  height: 400px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.expert-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.expert-basic-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.expert-name {
  font-size: 36px;
  font-weight: bold;
  color: #333;
  margin: 0 0 16px 0;
}

.expert-title {
  font-size: 20px;
  color: #666;
  margin: 0;
  line-height: 1.6;
}

.expert-content {
  padding: 40px;
}

.info-section {
  margin-bottom: 32px;
}

.info-section:last-child {
  margin-bottom: 0;
}

.info-section h2 {
  font-size: 24px;
  color: #333;
  margin: 0 0 16px 0;
  padding-bottom: 12px;
  border-bottom: 2px solid #B8D9E8;
}

.info-section p {
  font-size: 16px;
  color: #666;
  line-height: 1.8;
  margin: 0;
}

.specialty-list,
.qualification-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.specialty-list li,
.qualification-list li {
  font-size: 16px;
  color: #666;
  line-height: 2;
  padding-left: 24px;
  position: relative;
}

.specialty-list li:before,
.qualification-list li:before {
  content: '•';
  position: absolute;
  left: 8px;
  color: #B8D9E8;
  font-size: 20px;
}

.back-button {
  padding: 40px;
  text-align: center;
  border-top: 1px solid #eee;
}

.back-button button {
  padding: 12px 48px;
  font-size: 16px;
  color: white;
  background: linear-gradient(135deg, #B8D9E8 0%, #7AB8D6 100%);
  border: none;
  border-radius: 24px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.back-button button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(122, 184, 214, 0.4);
}

.loading-container {
  max-width: 1200px;
  margin: 0 auto;
  background: white;
  border-radius: 12px;
  padding: 60px;
  text-align: center;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.loading-container p {
  font-size: 18px;
  color: #666;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .expert-header {
    flex-direction: column;
    padding: 24px;
  }
  
  .expert-image-wrapper {
    width: 100%;
    height: 300px;
  }
  
  .expert-name {
    font-size: 28px;
  }
  
  .expert-title {
    font-size: 16px;
  }
  
  .expert-content {
    padding: 24px;
  }
  
  .info-section h2 {
    font-size: 20px;
  }
  
  .back-button {
    padding: 24px;
  }
}
</style>
